import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import {
  fetchVehicleTransmissionType,
  initializeVehicleTransmissionTypeScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleTransmissionType,
  saveVehicleTransmissionTypeTableState
} from "../../../redux/actions/vehicles/vehicleTransmissionType";
import VehicleTransmissionType from '../../../component/Vehicles/VehicleTransmissionType';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleTransmissionTypeScreen(props) {
  const {
    fetchVehicleTransmissionType,
    initVehicleTransmissionTypeScreen,
    showPageLevelLoader,
    vehicleTransmissionTypeListview,
    paginationInfo,
    screenPermissions,
    exportVehicleTransmissionType,
    isVehicleTransmissionTypeExportError,
    isVehicleTransmissionTypeExportSuccess,
    isLoading,
    savedTableState,
    saveVehicleTransmissionTypeTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleTransmissionTypeScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleTransmissionType(savedParams);
    } else {
      fetchVehicleTransmissionType({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleTransmissionType(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleTransmissionTypeTableState(tableState);
  };
  const handleCreateVehicleTransmissionType = () => {
    navigate(APP_URLS.VEHICLE_TRANSMISSIONTYPE.CREATE);
  }
  const editVehicleTransmissionTypeRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_TRANSMISSIONTYPE.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleTransmissionType = {
    handleCreateVehicleTransmissionType,
    exportVehicleTransmissionType,
    isVehicleTransmissionTypeExportError,
    isVehicleTransmissionTypeExportSuccess,
    editVehicleTransmissionTypeRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchVehicleTransmissionTypes: loadLazyData,
    tableData: {
      columns: vehicleTransmissionTypeListview?.columns,
      rows: vehicleTransmissionTypeListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleTransmissionType
        {...vehicleTransmissionType}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleTransmissionTypeScreen: () => dispatch(initializeVehicleTransmissionTypeScreen()),
    fetchVehicleTransmissionType: (payload) => dispatch(fetchVehicleTransmissionType(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleTransmissionType: (payload) => dispatch(exportVehicleTransmissionType(payload)),
    saveVehicleTransmissionTypeTableState: (payload) => dispatch(saveVehicleTransmissionTypeTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleTransmissionTypeCreateSuccess: selectFromVehicleTransmissionTypeReducer(
      state,
      "isVehicleTransmissionTypeCreateSuccess"
    ),
    vehicleTransmissionTypeListview: selectFromVehicleTransmissionTypeReducer(
      state,
      "vehicleTransmissionTypeListview"
    ),
    showPageLevelLoader: selectFromVehicleTransmissionTypeReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleTransmissionTypeReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleTransmissionTypeReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleTransmissionTypeReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleTransmissionTypeExportError: selectFromVehicleTransmissionTypeReducer(
      state,
      "isVehicleTransmissionTypeExportError"
    ),
    isVehicleTransmissionTypeExportSuccess: selectFromVehicleTransmissionTypeReducer(
      state,
      "isVehicleTransmissionTypeExportSuccess"
    ),
    savedTableState: selectFromVehicleTransmissionTypeReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleTransmissionTypeReducer = (state, path) => {
  return selectVehicleTransmissionTypeReducer(state)[path];
};

const selectVehicleTransmissionTypeReducer = ({ vehicleTransmissionTypeReducer }) => {
  return vehicleTransmissionTypeReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleTransmissionTypeScreen);
